var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "storefront"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 67,
    height: 68
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.76001,
    width: 66.48,
    height: 66.48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "storefront_2",
    d: "M58.2393 31.3685V53.39C58.2393 54.9135 57.6968 56.2177 56.6119 57.3026C55.527 58.3876 54.2228 58.93 52.6993 58.93H13.9193C12.3958 58.93 11.0916 58.3876 10.0066 57.3026C8.92173 56.2177 8.37927 54.9135 8.37927 53.39V31.3685C7.31744 30.399 6.49798 29.1525 5.92089 27.629C5.34381 26.1055 5.33227 24.4435 5.88627 22.643L8.79477 13.225C9.1641 12.0247 9.82198 11.0321 10.7684 10.2473C11.7148 9.46242 12.8113 9.07001 14.0578 9.07001H52.5608C53.8073 9.07001 54.8922 9.45088 55.8155 10.2126C56.7389 10.9744 57.4083 11.9785 57.8238 13.225L60.7323 22.643C61.2863 24.4435 61.2747 26.0824 60.6976 27.5598C60.1206 29.0371 59.3011 30.3067 58.2393 31.3685ZM39.4033 28.46C40.6498 28.46 41.5962 28.033 42.2425 27.1789C42.8889 26.3248 43.1428 25.3668 43.0043 24.305L41.4808 14.61H36.0793V24.859C36.0793 25.8285 36.4024 26.671 37.0488 27.3866C37.6951 28.1022 38.4799 28.46 39.4033 28.46ZM26.9383 28.46C28.0001 28.46 28.8657 28.1022 29.5351 27.3866C30.2046 26.671 30.5393 25.8285 30.5393 24.859V14.61H25.1378L23.6143 24.305C23.4296 25.413 23.672 26.3825 24.3414 27.2135C25.0108 28.0445 25.8764 28.46 26.9383 28.46ZM14.6118 28.46C15.4428 28.46 16.1699 28.1599 16.7931 27.5598C17.4164 26.9596 17.7973 26.1978 17.9358 25.2745L19.4593 14.61H14.0578L11.2878 23.8895C11.0108 24.8128 11.1608 25.8054 11.7379 26.8673C12.315 27.9291 13.2729 28.46 14.6118 28.46ZM52.0068 28.46C53.3456 28.46 54.3151 27.9291 54.9153 26.8673C55.5154 25.8054 55.6539 24.8128 55.3308 23.8895L52.4223 14.61H47.1593L48.6828 25.2745C48.8213 26.1978 49.2021 26.9596 49.8254 27.5598C50.4487 28.1599 51.1758 28.46 52.0068 28.46ZM13.9193 53.39H52.6993V33.8615C52.4684 33.9538 52.3184 34 52.2491 34H52.0068C50.7603 34 49.6638 33.7923 48.7174 33.3768C47.771 32.9613 46.8361 32.2918 45.9128 31.3685C45.0818 32.1995 44.1354 32.8458 43.0735 33.3075C42.0117 33.7692 40.8806 34 39.6803 34C38.4338 34 37.2681 33.7692 36.1831 33.3075C35.0982 32.8458 34.1403 32.1995 33.3093 31.3685C32.5244 32.1995 31.6126 32.8458 30.5739 33.3075C29.5351 33.7692 28.4156 34 27.2153 34C25.8764 34 24.6646 33.7692 23.5796 33.3075C22.4947 32.8458 21.5368 32.1995 20.7058 31.3685C19.7363 32.338 18.7783 33.019 17.8319 33.4114C16.8855 33.8038 15.8121 34 14.6118 34H14.3001C14.1847 34 14.0578 33.9538 13.9193 33.8615V53.39Z",
    fill: "#F57423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.e7fdb1b25746dde9a2bcac3ba2f6164a.svg";
export { ForwardRef as ReactComponent };